// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"1aeb58aa","796":"da4d4cbb"}[chunkId] + ".chunk.js";
};